import httpManager from "@/app/shared/utils/httpManager";

/**
 * @param {Number} id
 * @param {Object} body
 */

export async function changeChatbotStatus(id, body) {
  await httpManager.put(`/chatbots/${id}/status/`, body);
}
